import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { QuoteDataService } from '../../services/quote-data.service'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'
import { Observable, of } from 'rxjs'
import { AuthService, User } from '@spartacus/core'
import { switchMap } from 'rxjs/operators'
import { EndUserAddress, DeliveryAddress } from '../../model/address-models'
import { Router } from '@angular/router'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import {
  OrderType,
  QuoteStatus,
} from '../../../../../models/status/status.model'
import { NgSelectComponent } from '@ng-select/ng-select'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { CommonService } from '../../../../../shared/services/common.service'
import { environment } from '../../../../../../environments/environment'

@Component({
  standalone: false,
  selector: 'vs-end-customer-address',
  templateUrl: './end-customer-address.component.html',
  styleUrls: ['./end-customer-address.component.scss'],
})
export class EndCustomerAddressComponent implements OnInit, OnChanges {
  @Input() orderType
  @Input() isSubmitted
  @Input() endUserAddress: EndUserAddress
  @Input() deliveryAddress: DeliveryAddress
  @Input() legalEntity: string
  @Input() endUserIndustryName: string
  @Input() count = 1
  @Input() selectedAddress
  @Input() validationGroup = 'end-user'
  @Output() endCountryData = new EventEmitter<string>()
  @Output() legalEntityChange = new EventEmitter<string>()
  @Output() endCustomerAddressUpdate = new EventEmitter<EndUserAddress>()
  @Output() endUserIndustryUpdate = new EventEmitter<string>()
  @Input() rfqTypes
  @Input() orderChanged
  @Input() quoteCartType
  @ViewChild('countryFocus') countryFocus: NgSelectComponent
  @ViewChild('stateFocus') stateFocus: NgSelectComponent
  @ViewChild('endUserIndustryFocus') endUserIndustryFocus: NgSelectComponent
  @ViewChild('legalEntityFocus') legalEntityFocus: NgSelectComponent
  endCustomerAddress: FormGroup
  selectedCountry: any
  countryNames: any
  countryRegionNames: any
  isShipToAddress = false
  endUserIndustries: any
  orderTypeName: string
  isDisableFormControl = false
  isCopySoldToAddressData
  cartId: string
  userType: string
  user$: Observable<User>
  cartData: any
  cartData$: Observable<any>
  cartLoaded: boolean
  productData: any
  cartName = 'rfqcart'
  endUserData$: Observable<any>
  endUserData: any
  isLoggedinUser = false
  legalEntityData$: Observable<any>
  legalEntityData: any
  componentAddress = 'End Customer'
  userAddressData: any
  userAddressData$: Observable<any>
  public radioSelected: string
  public newAdd: boolean
  public userRoles: string = 'userRoles'
  public term: string
  OrderType = OrderType
  isSelectAddress = false
  userAddressList: any
  selectedEndUserIndustry: any
  selectedState: any
  fullName: string
  firstIndustry = false
  firstRegion = false
  endData: any
  countryData: any
  isSubmittedCopy: boolean = false
  stateData: any
  billToValidation: boolean
  deliveryValidation: boolean
  QuoteStatus = QuoteStatus
  maxVal
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private data: QuoteDataService,
    private quoteCheckoutService: QuoteCheckoutService,
    private auth: AuthService,

    private router: Router,
    private quoteCartService: QuoteCartService,
    private quoteDataService: QuoteDataService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.quoteDataService.recieveBillToAddressValidation.subscribe(
      (valid: boolean) => {
        this.billToValidation = valid
      }
    )
    this.quoteDataService.recieveDeliveryAddressValidation.subscribe(
      (valid: boolean) => {
        this.deliveryValidation = valid
      }
    )
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          this.maxVal = 40
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          this.maxVal = 35
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
        this.maxVal = 40
      } else {
        this.userType = 'anonymous'
        this.maxVal = 35
      }
    })
    this.getEndUserIndustry()
    this.endCustomerAddressFormDetails()

    this.quoteCartService.retainEndUserIndustry.subscribe((data) => {
      this.endUserIndustryName = data
      this.endCustomerAddress.controls['endUserIndustry'].setValue(
        this.endUserIndustryName || null
      )
    })

    this.data.getShipToAddressData().subscribe((data) => {
      if (data && this.isCopySoldToAddressData) {
        if (data.country) {
          const regions = 'regions'
          this.commonService
            .getData(
              environment.occBaseUrl +
                environment.getCountryURL +
                data.country +
                '/regions?fields=DEFAULT'
            )
            .subscribe(
              (success) => {
                this.countryRegionNames = success[regions]
              },
              (error) => {}
            )
        }
        this.endCustomerAddress.patchValue(data)
        this.selectedState = data.state
        this.data.setEndCustomerData(data)
      }
    })
    this.endCustomerAddressUpdate.emit(this.selectedAddress)
    this.endCustomerAddress.valueChanges.subscribe((data) => {
      if (
        !this.isCopySoldToAddressData &&
        this.endUserIndustry.valid &&
        this.endUserRegion.valid
      ) {
        this.data.sendEndUserAddressValidation(this.endCustomerAddress.valid)
      }
      if (!this.isCopySoldToAddressData && this.userType === 'anonymous') {
        this.endUserAddress = {
          firstName: data.endUserName,
          country: this.countryData,
          companyName: data.companyName,
          line1: data.line1,
          line2: data.line2,
          postalCode: data.postalCode,
          town: data.city,
          region: this.stateData,
        }

        this.endCustomerAddressUpdate.emit(this.endUserAddress)
      } else if (
        this.isCopySoldToAddressData &&
        this.userType === 'anonymous'
      ) {
        if (this.endUserAddress !== undefined && data.endUserName) {
          this.endUserAddress.firstName = data.endUserName
          this.endCustomerAddressUpdate.emit(this.endUserAddress)
        }

        if (
          data.endUserName !== undefined &&
          data.endUserName.trim().length > 0
        ) {
          this.endCustomerAddressUpdate.emit(this.endUserAddress)
          this.data.sendEndUserAddressValidation(true)
        } else {
          this.data.sendEndUserAddressValidation(false)
        }
      } else {
        this.data.sendEndUserAddressValidation(this.endCustomerAddress.valid)
      }
    })

    this.getLegalEntity()

    this.quoteCheckoutService.checkSubmission.subscribe((data) => {
      this.isSubmittedCopy = data
      if (
        this.userType == 'current' &&
        data === true &&
        this.endCustomerAddress.controls['endUserIndustry'].invalid
      ) {
        this.scrollToError()
      } else if (
        data === true &&
        this.userType == 'anonymous' &&
        this.billToValidation &&
        this.deliveryValidation &&
        this.endCustomerAddress.valid
      ) {
        this.scrollToError()
      }
    })
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.parentElement.focus()
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    )

    this.scrollTo(firstElementWithError)
  }
  get chkBoxEndUser() {
    return this.endCustomerAddress.get('chkBoxEndUser')
  }
  get endUserName() {
    return this.endCustomerAddress.get('endUserName')
  }
  get line1() {
    return this.endCustomerAddress.get('line1')
  }
  get country() {
    return this.endCustomerAddress.get('country')
  }
  get state() {
    return this.endCustomerAddress.get('state')
  }
  get city() {
    return this.endCustomerAddress.get('city')
  }
  get postalCode() {
    return this.endCustomerAddress.get('postalCode')
  }
  get endUserIndustry() {
    return this.endCustomerAddress.get('endUserIndustry')
  }
  get endUserRegion() {
    return this.endCustomerAddress.get('endUserRegion')
  }
  ngOnChanges(changes) {
    if (this.userType == 'current') {
      this.endUserAddress = this.selectedAddress
    }
    if (this.quoteCartType === QuoteStatus.EDIT) {
      if (this.endCustomerAddress) {
        this.endCustomerAddress.controls['endUserIndustry'].disable()
      }
    }
    if (
      this.userType == 'current' &&
      changes?.selectedAddress?.currentValue !=
        changes?.selectedAddress?.previousValue
    ) {
      this.endCustomerAddressUpdate.emit(this.selectedAddress)
    }
    if (this.isCopySoldToAddressData) {
      this.isSubmitted = false
      this.endCustomerAddress.patchValue({
        line1: this.deliveryAddress?.line1,
        companyName: this.deliveryAddress?.companyName,
        line2: this.deliveryAddress?.line2,
        country: this.deliveryAddress?.country?.name,
        postalCode: this.deliveryAddress?.postalCode,
        state: this.deliveryAddress?.region?.name,
        city: this.deliveryAddress?.town,
      })
      this.endUserAddress = this.deliveryAddress
      if (
        this.endUserAddress !== undefined &&
        this.endUserAddress['firstName'] !== undefined
      ) {
        this.endUserAddress.firstName =
          this.endCustomerAddress.controls['endUserName'].value
      }
      this.endCustomerAddress.controls['endUserName'].enable()
      this.endCustomerAddress.controls['line1'].disable()
      this.endCustomerAddress.controls['line2'].disable()
      this.endCustomerAddress.controls['country'].disable()
      this.endCustomerAddress.controls['state'].disable()
      this.endCustomerAddress.controls['city'].disable()
      this.endCustomerAddress.controls['postalCode'].disable()
      this.endCustomerAddress.controls['endUserRegion'].enable()
      if (this.quoteCartType === QuoteStatus.EDIT) {
        this.endCustomerAddress.controls['endUserIndustry'].disable()
      } else {
        this.endCustomerAddress.controls['endUserIndustry'].enable()
      }
      this.endCustomerAddressUpdate.emit(this.endUserAddress)
    }

    if (this.rfqTypes) {
      if (this.orderType === this.OrderType.STOCK) {
        this.isCopySoldToAddressData = true
        this.onCopyAddress()
        if (this.userType === 'current') {
          this.selectedAddress = this.deliveryAddress
          this.endCustomerAddressUpdate.emit(this.selectedAddress)
          this.orderChanged = false
        }
      }
      if (this.orderType === this.OrderType.RESALE) {
        // if (this.orderChanged === true) {
        this.isCopySoldToAddressData = false
        if (this.endCustomerAddress) {
          this.endCustomerAddress.enable()
        }
        this.onCopyAddress()
        this.orderChanged = false
        // }
        // this.orderChanged = false;
      }
    }
  }

  endCustomerAddressFormDetails() {
    this.endCustomerAddress = this.formBuilder.group({
      endUserName: new FormControl('', Validators.required),
      line1: new FormControl('', Validators.required),
      line2: new FormControl(''),
      country: new FormControl(null, Validators.required),
      state: new FormControl(null),
      city: new FormControl('', Validators.required),
      postalCode: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(10),
          Validators.pattern(/^[a-zA-Z0-9 -]*$/),
        ],
      ],
      endUserIndustry: new FormControl(null, Validators.required),
      endUserRegion: new FormControl(null, Validators.required),
    })
    if (this.endUserAddress) {
      this.endCustomerAddress.patchValue({
        line1: this.endUserAddress?.line1,
        line2: this.endUserAddress?.line2,
        country: this.endUserAddress?.country?.name
          ? this.endUserAddress?.country?.name
          : null,
        state: this.endUserAddress?.region?.name
          ? this.endUserAddress?.region?.name
          : null,
        postalCode: this.endUserAddress?.postalCode,
        city: this.endUserAddress?.town,
        endUserIndustry: this.endUserIndustryName || null,
      })
      this.endCustomerAddress.controls['endUserName'].setValue(
        this.endUserAddress?.firstName
      )
      this.countryData = this.endUserAddress?.country
      this.stateData = this.endUserAddress?.region

      this.endCountryData.emit(this.endUserAddress?.country?.isocode)
      this.quoteDataService.sendEndUserAddressValidation(true)
    } else {
    }
    this.getCountryData()
  }

  getEntity(event) {
    this.orderTypeName = this.orderType
    this.firstRegion = false
    this.endCustomerAddress.controls['endUserRegion'].setValue(event)
    this.legalEntityChange.emit(event)
  }

  getCountryData() {
    const countries = 'countries'
    const urlParam = [countries]
    const apiUrl = this.commonService.constructUrl(urlParam)
    // const apiParams = { fields: 'DEFAULT', type: 'BILLING' };
    const apiParams = { fields: 'DEFAULT' }

    this.commonService.getData(apiUrl, apiParams).subscribe(
      (success) => {
        this.countryNames = success[countries]
      },
      (error) => {}
    )
  }

  saveCountryData() {
    this.countryNames.forEach((element) => {
      if (
        element.isocode === this.endCustomerAddress.controls['country'].value
      ) {
        this.countryData = element
        this.endUserAddress.country = element
        this.endCustomerAddress.controls['country'].setValue(
          this.endCustomerAddress.controls['country'].value
        )
      }
    })
    this.selectedCountry = this.endCustomerAddress.controls['country'].value
    this.endCountryData.emit(this.selectedCountry)

    if (this.selectedCountry == 'CN') {
      this.endCustomerAddress.controls['postalCode'].clearValidators()
    } else {
      this.endCustomerAddress.controls['postalCode'].setValidators([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(10),
        Validators.pattern(/^[a-zA-Z0-9 -]*$/),
      ])
    }
    this.endCustomerAddress.controls['postalCode'].updateValueAndValidity()
    const regions = 'regions'
    this.commonService
      .getData(
        environment.occBaseUrl +
          environment.getCountryURL +
          this.selectedCountry +
          '/regions?fields=DEFAULT'
      )
      .subscribe(
        (success) => {
          this.countryRegionNames = success[regions]
          this.countryRegionNames = success[regions]
          if (this.countryRegionNames?.length > 0) {
            this.endCustomerAddress.controls['state'].setValidators([
              Validators.required,
            ])
          } else {
            this.endCustomerAddress.controls['state'].clearValidators()
          }
          this.endCustomerAddress.controls['state'].updateValueAndValidity()
        },
        (error) => {}
      )
  }
  resetAddress() {
    if (!this.isCopySoldToAddressData) {
      this.endCustomerAddress.controls['line1'].reset()
      this.endCustomerAddress.controls['line2'].reset()
      this.endCustomerAddress.controls['country'].reset()
      this.endCustomerAddress.controls['state'].reset()
      this.endCustomerAddress.controls['city'].reset()
      this.endCustomerAddress.controls['postalCode'].reset()
      this.endCustomerAddress.controls['endUserRegion'].reset()
      this.endUserAddress = null
      if (this.userType == 'current') {
        this.endCustomerAddressUpdate.emit(this.selectedAddress)
      } else {
        this.endCustomerAddressUpdate.emit(this.endUserAddress)
      }
    }
  }
  onCopyAddress() {
    if (this.isCopySoldToAddressData == false && this.endCustomerAddress) {
      // this.endUserAddress = null;

      this.endUserAddress = {
        firstName: this.endCustomerAddress.controls['endUserName'].value,
      }

      this.endCustomerAddress.controls['line1'].enable()
      this.endCustomerAddress.controls['line2'].enable()
      this.endCustomerAddress.controls['country'].enable()
      this.endCustomerAddress.controls['state'].enable()
      this.endCustomerAddress.controls['city'].enable()
      this.endCustomerAddress.controls['postalCode'].enable()
      this.endCustomerAddress.controls['endUserName'].enable()
      this.endCustomerAddress.controls['endUserRegion'].enable()
      if (this.quoteCartType === QuoteStatus.EDIT) {
        this.endCustomerAddress.controls['endUserIndustry'].disable()
      } else {
        this.endCustomerAddress.controls['endUserIndustry'].enable()
      }
      this.orderType = ''
      if (this.userType == 'current') {
        this.endCustomerAddressUpdate.emit(this.selectedAddress)
      } else {
        this.endCustomerAddressUpdate.emit(this.endUserAddress)
      }
    } else if (this.isCopySoldToAddressData) {
      this.isSubmitted = false
      this.endCustomerAddress.patchValue({
        line1: this.deliveryAddress?.line1,
        line2: this.deliveryAddress?.line2,
        country: this.deliveryAddress?.country?.name,
        state: this.deliveryAddress?.region?.name,
        city: this.deliveryAddress?.town,
        postalCode: this.deliveryAddress?.postalCode,
      })

      this.endUserAddress = this.deliveryAddress
      // this.endCustomerAddress.controls.endUserName.enable();
      // this.endCustomerAddress.disable();
      this.endCustomerAddress.controls['endUserName'].enable()
      this.endCustomerAddress.controls['line1'].disable()
      this.endCustomerAddress.controls['line2'].disable()
      this.endCustomerAddress.controls['country'].disable()
      this.endCustomerAddress.controls['state'].disable()
      this.endCustomerAddress.controls['city'].disable()
      this.endCustomerAddress.controls['postalCode'].disable()
      this.endCustomerAddress.controls['endUserRegion'].enable()
      if (
        this.endUserAddress !== undefined &&
        this.endUserAddress['firstName'] !== undefined
      ) {
        this.endUserAddress.firstName =
          this.endCustomerAddress.controls['endUserName'].value
      }

      if (this.quoteCartType === QuoteStatus.EDIT) {
        this.endCustomerAddress.controls['endUserIndustry'].disable()
      } else {
        this.endCustomerAddress.controls['endUserIndustry'].enable()
      }

      this.endCustomerAddressUpdate.emit(this.endUserAddress)
      // this.endCustomerAddress.disable();
    }
  }

  getLegalEntity() {
    const legalEntity = 'legalEntity'
    this.legalEntityData$ = this.quoteCheckoutService.getLegalEntity(
      this.userType
    )
    this.legalEntityData$.subscribe((data: any) => {
      this.legalEntityData = data[legalEntity]
      this.quoteCartService.retainLegalEntityCollection.next(
        this.legalEntityData
      )

      this.legalEntityData.forEach((element) => {
        if (element.code === this.legalEntity) {
          this.endCustomerAddress.controls['endUserRegion'].setValue(
            element.value
          )
        }
      })
    })
  }

  getEndUserIndustry() {
    const endUserIndustries = 'endUserIndustries'
    this.endUserData$ = this.quoteCheckoutService.getEndUserIndustry(
      this.userType
    )
    this.endUserData$.subscribe((data: any) => {
      this.endUserIndustries = data[endUserIndustries]
    })
  }

  addAddress() {
    this.newAdd = true
  }
  selectedAdd(event) {
    this.selectedAddress = event
    this.endCountryData.emit(event?.country?.isocode)
    this.endUserAddress = event

    this.endCustomerAddressUpdate.emit(this.endUserAddress)
    this.closeForm(false)
  }
  closeForm(event) {
    this.isSelectAddress = event
  }
  setEndUserIndustry() {
    this.firstIndustry = false
    this.endUserIndustryUpdate.emit(this.endUserIndustry.value)
  }

  selectAddress() {
    this.isSelectAddress = true
  }
  selectEndUserIndustry() {
    this.endUserIndustryUpdate.emit(
      this.endCustomerAddress.controls['endUserIndustry'].value
    )
    if (this.userType == 'current') {
      this.data.sendEndUserAddressValidation(
        this.endCustomerAddress.controls['endUserIndustry'].valid
      )
    }
  }
  selectState() {
    this.countryRegionNames.forEach((element) => {
      if (element.isocode === this.endCustomerAddress.controls['state'].value) {
        this.stateData = element
        this.endUserAddress.region = element
      }
    })
  }
  acceptNumberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 43 &&
      charCode !== 45 &&
      charCode !== 40 &&
      charCode !== 41 &&
      charCode !== 46 &&
      charCode !== 62
    ) {
      return false
    }
    return true
  }
}
